import { useAuth } from '@butternetwork/shared-auth';

/**
 * Shown at the very top of the page when auth bypass is active in dev.
 * Makes the mode visually impossible to miss.
 * Production builds throw before this can render, so this is dev-only by construction.
 */
export function BypassBanner() {
  const { user } = useAuth();
  if (!user?.isDevBypass) return null;

  return (
    <div
      role="alert"
      className="w-full bg-amber-500 text-black text-center text-xs font-semibold py-1 px-4 tracking-wide"
    >
      ⚠ AUTH BYPASS — dev only, never deploy this build
    </div>
  );
}
